import CampaignApprovals from './CampaignApprovals';

const CampaignApprovalsConfig = {
	settings: {},
	routes: [
		{
			path: '/apps/campaign-approvals',
			component: CampaignApprovals
		}
	]
};

export default CampaignApprovalsConfig;
